import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';

export interface VoIPPeerDialogInf {
  selectedItem: any;
  isEditMode?: boolean;
  cacProfiles: any;
}

export const cacStateOptions = [
  { text: 'Active', value: 'UNBLOCK' },
  { text: 'Blocked', value: 'BLOCK' },
  { text: 'Blocked for Incoming', value: 'BLOCK_INCOMING' },
  { text: 'Blocked for Outgoing', value: 'BLOCK_OUTGOING' },
];

@Component({
  selector: 'offline-voip-peers-dialog',
  templateUrl: './offline-voip-peers-dialog.component.html',
  styleUrls: ['./offline-voip-peers-dialog.component.scss']
})
export class OfflineVoipPeersDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<OfflineVoipPeersDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: VoIPPeerDialogInf,
              private userPrivilege: UserPrivilegeService) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  sipHeaderOptions = ['NA', 'IP_PHONES', 'SIP_TRUNK', 'IP_PBX', 'PBX', 'PSTN', 'TEAMS'];
  resourceGroups;
  cacStateOptions = cacStateOptions;
  title;
  isAuthorized: boolean;

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();

    this.title = `${this.data.isEditMode ? 'EDIT' : 'ADD'} VOIP PEER`;
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }
}
